import { Box, Divider, StackDivider, Text, VStack } from '@chakra-ui/react'
import IndicatorEvent from './IndicatorEvent'

const Indicators = () => {
	return (
		<Box w="full">
			<Text fontSize="xl" fontWeight="bold" mb="4">Indicadores de Saúde</Text>
			<VStack spacing={8} divider={<StackDivider w="full" />} >
				<IndicatorEvent />
				<IndicatorEvent />
				<IndicatorEvent />
			</VStack>
		</Box>
	)
}

export default Indicators
